import { useQueryClient } from 'react-query';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useAppScopeStore } from '@frontend/scope';

export const useScheduleRequestListAndCountInvalidation = () => {
  const queryClient = useQueryClient();
  const { selectedLocationIds } = useAppScopeStore();
  const { invalidateBookingSubmissions } = SchedulerV3.Helpers.useSchedulerV3InvalidateQueries();

  const invalidateScheduleRequestListAndCountV2 = () => {
    queryClient.invalidateQueries({
      predicate: ({ queryKey }) => {
        return queryKey.includes('scheduleRequestCount') || queryKey.includes('scheduleRequestList');
      },
    });
  };

  const invalidateScheduleRequestListAndCount = () => {
    // For v2
    invalidateScheduleRequestListAndCountV2();
    // For v3
    invalidateBookingSubmissions(selectedLocationIds);
  };

  return {
    invalidateScheduleRequestListAndCountV2,
    invalidateScheduleRequestListAndCount,
  };
};
